import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HiArrowUpRight } from "react-icons/hi2";
import api, { mediaUrl } from "../../lib/api";

export default function FeaturedWork() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let live = true;
    api.get("/api/projects")
      .then(({ data }) => {
        if (!live) return;
        const all = data.items || [];
        const featured = all.filter((p) => p.featured);
        setItems((featured.length ? featured : all).slice(0, 6));
      })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  return (
    <section className="section" id="work">
      <div className="container-x">
        <div className="section-head reveal">
          <div className="section-head__title">
            <span className="eyebrow">Selected work</span>
            <h2>
              Featured
              <br />
              <span className="it text-accent">case studies.</span>
            </h2>
          </div>
          <div className="section-head__aside">
            <p>
              A handful of recent stores I've engineered. Built for speed,
              tuned for conversion, shipped for the long run.
            </p>
            <Link to="/shopify-portfolio" className="btn btn--ghost" style={{ marginTop: 16 }}>
              See all stores
              <span className="arrow"><HiArrowUpRight /></span>
            </Link>
          </div>
        </div>

        {items.length > 0 && (
          <div className="work-grid">
            {items.map((it) => (
              <a
                key={it.id}
                className="work reveal"
                href={it.url}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={`${it.title} — open site`}
              >
                <div className="work__media">
                  {it.category && (
                    <span className="work__badge"><span className="dot" /> {it.category}</span>
                  )}
                  <span className="work__arrow"><HiArrowUpRight /></span>
                  {it.image && <img src={mediaUrl(it.image)} alt={`${it.title} screenshot`} loading="lazy" />}
                </div>
                <div className="work__body">
                  <span className="work__title">{it.title}</span>
                  <span className="work__cat">
                    {(() => { try { return new URL(it.url).hostname; } catch { return ""; } })()}
                  </span>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
